import type {
  Document,
  DocumentUploadExistingFilePayload,
} from "./document.type";
import type { Nullable } from "@/types";

export const convertDocumentToExistingFilePayload = (
  document?: Nullable<Document>
): DocumentUploadExistingFilePayload | undefined => {
  if (!document) return undefined;

  return {
    name: document.name,
    path: document.path,
  };
};

export const convertDocumentsToExistingPayload = (
  documents?: Document[]
): DocumentUploadExistingFilePayload[] => {
  return (documents ?? [])
    .map(convertDocumentToExistingFilePayload)
    .filter((payload) => !!payload);
};
